import { FC, PropsWithChildren } from 'react';

import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { useRoutedStepsOrchestratorContext } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.context';

import useGetClaimGroupSummary from '../hooks/useGetClaimGroupSummary';
import { useInitializeClaimGroupId } from '../hooks/useInitializeClaimGroupId';
import { useInitializeClaims } from '../hooks/useInitializeClaims';
import { useInitializeIssue } from '../hooks/useInitializeIssue';
import { useInitializeReason } from '../hooks/useInitializeReason';
import { ClaimGroupReasonPageStepValues } from '../NewClaimGroupReasonPage/NewClaimGroupReasonPage.types';

export const NewClaimGroupDocumentPageRelatedToClaimWrapper: FC<
  PropsWithChildren
> = ({ children }) => {
  const { values } =
    useRoutedStepsOrchestratorContext<ClaimGroupReasonPageStepValues>();
  const claimGroupId = values?.claimGroupId;

  const { claims } = useGetClaimGroupSummary({
    claimGroupId,
    suspense: true,
  });

  const firstClaim = claims?.at(0);
  const reason = values?.reason;

  useInitializeIssue({
    claim: firstClaim,
  });
  useInitializeClaimGroupId();
  useInitializeClaims({
    claimGroupId,
  });
  useInitializeReason({
    claimGroupId,
    claim: firstClaim,
  });

  const isClaimsLoaded = claimGroupId && !!claims?.length;

  const hasReasonToLoad = isClaimsLoaded && firstClaim?.reasonId;
  const isReasonOk = hasReasonToLoad ? !!reason : true;

  if (!isClaimsLoaded || !isReasonOk) {
    return <BaseLoader />;
  }

  return <>{children}</>;
};
